export function calculateTrend(before, after) {
  const growthDifference = after - before;
  const trend = growthDifference / before;
  return Math.round(trend * 100);
}
